import './FieldSelect.scss';
import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { PlusCircledIcon } from '@radix-ui/react-icons';


const FieldSelect = ({ options, onChange, value }) => {

    const DropdownIndicator = (props) => (
        <components.DropdownIndicator {...props}>
            <PlusCircledIcon color='green' transform='scale(1.3)' />
        </components.DropdownIndicator>
    );

    return (
        <div>
            <Select
                options={options}
                className='FieldSelect'
                placeholder={'Add Field'}
                onChange={(e) => onChange(e)}
                components={{ DropdownIndicator }}
                value={value}

                styles={{
                    indicatorSeparator: () => ({ display: 'none' }),
                    menu: (base) => ({
                        ...base,
                        width: 'max-content',
                        minWidth: '100%',
                    }),
                    control: (base) => ({
                        ...base,
                        flexDirection: 'row-reverse',
                        border: 'none',
                        boxShadow: 'none',
                        background: 'transparent',
                    }),
                    placeholder: (base) => ({
                        ...base,
                        color: 'green',
                        fontSize: '14px',
                        fontWeight: '500'
                    })
                }}

            />
        </div>
    );
};

FieldSelect.defaultProps = {
};

FieldSelect.propTypes = {
    options: PropTypes.shape(),
    onChange: PropTypes.func,
    value: PropTypes.shape(),
};

export default FieldSelect;